<template>
  <div class="checkbox-select__dropdown" :class="{ activeSearch: showLoader }">
    <div class="checkbox-select__search-wrapp">
      <input
        type="text"
        @focus="showLoader = true"
        @blur="showLoader = false"
        placeholder="search filters..."
        v-model="search"
      >
    </div>

    <div class="checkbox-select__col">
      <div class="checkbox-select__select-all">
        <label :for="`selectAll_${id}`">{{selectAllText}}</label>
        <input type="checkbox" :id="`selectAll_${id}`" v-model="allSelected">
      </div>
      <div class="checkbox-select__info">{{checkedFilters.length}} SELECTED</div>
    </div>

    <ul class="checkbox-select__filters-wrapp" data-simplebar-auto-hide="false">
      <li v-for="(filter, index) in filteredList" :key="filter.value">
        <div class="checkbox-select__check-wrapp">
          <input
            :id="`filter_${id}_${index}`"
            class="conditions-check"
            v-model="checkedFilters"
            :value="filter.value"
            type="checkbox"
          >
          <label :for="`filter_${id}_${index}`">{{ filter.text }}</label>
        </div>
      </li>
    </ul>

    <div class="d-flex justify-content-end">
      <button class="btn btn-link" @click="$emit('updateFilterCustom', checkedFilters)">Filter</button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class MultiSelectSearchable extends Vue {
  @Prop({
    type: Array,
    default: () => {
      return [];
    }
  })
  list;

  @Prop({
    type: String,
    default: ""
  })
  id;

  search = "";
  checkedFilters = [];
  allSelected = false;
  selectAllText = "Select All";
  dropdown = false;
  showLoader = false;

  get filteredList() {
    return this.list.filter(item => {
      const text =  typeof item === 'object' && item.hasOwnProperty('text') ? item.text : item

      return text.toLowerCase().includes(this.search.toLowerCase())
    });
  }

  @Watch('allSelected')
  selectAll(val, oldVal) {
    let filter;

    this.checkedFilters = [];
    this.selectAllText =
      this.selectAllText === "Select All" ? "Clear All" : "Select All";
    if (val) {
      this.list.forEach((item) => {
        this.checkedFilters.push(item.value.toString());
      })
    }
  }

  showDropdown() {
    if (this.dropdown === false) {
      this.dropdown = true;
    } else {
      this.dropdown = false;
    }
  }

  /* created () {
        const customScroll = new SimpleBar(document.getElementById('customScroll'))
    } */
}
</script>

<style lang="scss" scoped>
textarea,
input {
  appearance: none;
  border-radius: 0;

  &:focus {
    outline: 0;
  }
}

ol,
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.checkbox-select {
  position: relative;
  max-width: 440px;
  width: 100%;

  @media only screen and (max-width: 600px) {
    margin: 100px auto 0;
  }

  &__title {
    font-size: 25px;
    flex: 1;
    padding-right: 25px;
    letter-spacing: 1px;
    @media only screen and (max-width: 600px) {
      font-size: 19px;
    }
  }

  &__dropdown {
    // opacity: 0;
    // visibility: hidden;
    // background: #fff
    //   url("http://res.cloudinary.com/dnhvfgp9c/image/upload/v1521734636/bcg-pattern.png")
    //   repeat;
    // position: absolute;
    left: 0;
    right: 0;
    box-shadow: 0 12px 15px 6px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 8px 8px;
    overflow: hidden;
    padding-bottom: 10px;

    &:after,
    &:before {
      position: absolute;
      content: "";
      top: 0;
      display: block;
      height: 4px;
      z-index: 1;
    }

    &:after {
      opacity: 0;
      background: #000;
      left: -200px;
      width: 200px;
      background-color: #2980b9;
      transition: opacity 0.3s ease;
      animation: load 1.8s linear infinite;
      background: linear-gradient(
        135deg,
        rgba(143, 36, 237, 1) 20%,
        rgba(143, 36, 237, 1) 20%,
        rgba(143, 36, 237, 1) 22%,
        rgba(143, 36, 237, 1) 25%,
        rgba(16, 124, 179, 1) 100%
      );
    }

    &:before {
      width: 100%;
      background-color: #000;
    }

    &.activeSearch {
      &:after {
        opacity: 1;
      }
    }

    .simplebar-scrollbar {
      width: 3px;
      right: 1px;
    }
  }
  &__search-wrapp {
    padding: 10px 25px 5px;

    @media only screen and (max-width: 600px) {
      padding: 10px 15px 5px;
    }

    input {
      width: 100%;
      height: 40px;
      border-width: 0 0 2px;
      border-style: solid;
      border-color: #000;
      font-size: 16px;
      font-family: "Roboto Slab", serif;
      background: transparent;
    }
    ::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      color: #b8b8b8;
      opacity: 1;
    }
    ::-moz-placeholder {
      /* Firefox 19+ */
      color: #b8b8b8;
      opacity: 1;
    }
    :-ms-input-placeholder {
      /* IE 10+ */
      color: #b8b8b8;
      opacity: 1;
    }
    :-moz-placeholder {
      /* Firefox 18- */
      color: #b8b8b8;
      opacity: 1;
    }
  }
  &__col {
    display: flex;
    font-size: 12px;
    padding: 0 25px;
    justify-content: space-between;
    text-transform: uppercase;
    @media only screen and (max-width: 600px) {
      padding: 0 15px;
    }
  }
  &__select-all {
    label {
      cursor: pointer;
    }
    input {
      display: none;
    }
  }
  &__filters-wrapp {
    margin-top: 20px;
    height: 157px;
    overflow-y: auto;

    li {
      text-align: left;
    }
  }

  &__check-wrapp {
    position: relative;
    padding: 0 25px;
    margin-bottom: 5px;

    @media only screen and (max-width: 600px) {
      padding: 0 15px;
    }

    input[type="checkbox"] {
      display: none;

      & + label {
        position: relative;
        cursor: pointer;
        font-size: 16px;
        line-height: 22px;
        padding-left: 30px;
        display: inline-block;
        user-select: none;
        transition: padding 0.25s ease;

        &:after {
          border: solid 2px #000;
          content: "";
          width: 22px;
          height: 22px;
          top: 0;
          left: 0;
          position: absolute;
        }

        &:before {
          width: 14px;
          height: 14px;
          content: "";
          position: absolute;
          top: 4px;
          left: 4px;
          background-color: #000;
          opacity: 0;
          will-change: transform;
          transform: scale(0.5);
          transition: all 0.2s ease;
        }

        &:hover {
          padding-left: 32px;
        }
      }

      &:checked {
        & + label {
          &:before {
            opacity: 1;
            transform: scale(1);
          }
        }
      }
    }
  }
}

@keyframes load {
  0% {
    left: -200px;
    width: 20%;
  }
  50% {
    width: 40%;
  }
  70% {
    width: 60%;
  }
  80% {
    left: 50%;
  }
  95% {
    left: 120%;
  }
  100% {
    left: 100%;
  }
}

.link {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 20px;
  z-index: 9999;

  a {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #fff;
  }

  .fa {
    font-size: 28px;
    margin-right: 8px;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/vendors/vue-good-table/components/MultiSelectSearchable.vue